import * as z from "zod";

export enum ContentGenerationContextToolType {
  CUSTOMER_AGENT = "customer-agent",
  GET_PDP_PRODUCT_DESCRIPTION = "get-pdp-product-description",
  PRODUCT_REVIEWS = "product-reviews",
  GENERATE_DISCOUNT_CODE = "generate-discount-code",
}

const customerAgentToolSchema = z.object({
  type: z.literal(ContentGenerationContextToolType.CUSTOMER_AGENT),
  params: z.object({}),
});

const getPdpProductDescriptionToolSchema = z.object({
  type: z.literal(ContentGenerationContextToolType.GET_PDP_PRODUCT_DESCRIPTION),
  params: z.object({}),
});

const productReviewsToolSchema = z.object({
  type: z.literal(ContentGenerationContextToolType.PRODUCT_REVIEWS),
  params: z.object({}),
});

export enum DiscountUsageMode {
  NEVER = "never",
  ALWAYS = "always",
  AGENT_DECIDES = "agent_decides",
}

const generateDiscountCodeToolParamsSchema = z.object({
  discountIds: z.array(z.string()),
  usageMode: z
    .enum([
      DiscountUsageMode.NEVER,
      DiscountUsageMode.ALWAYS,
      DiscountUsageMode.AGENT_DECIDES,
    ])
    .default(DiscountUsageMode.AGENT_DECIDES),
});

export type GenerateDiscountCodeToolParams = z.infer<
  typeof generateDiscountCodeToolParamsSchema
>;

const generateDiscountCodeToolSchema = z.object({
  type: z.literal(ContentGenerationContextToolType.GENERATE_DISCOUNT_CODE),
  params: generateDiscountCodeToolParamsSchema,
});

// Specify which context tools are available for the content generation here
const contentGenerationContextToolSchema_ = z.discriminatedUnion("type", [
  customerAgentToolSchema,
  getPdpProductDescriptionToolSchema,
  productReviewsToolSchema,
  generateDiscountCodeToolSchema,
]);
export const contentGenerationContextToolSchema: z.ZodType<ContentGenerationContextTool> =
  contentGenerationContextToolSchema_;
export type ContentGenerationContextTool = z.infer<
  typeof contentGenerationContextToolSchema_
>;
